var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row justify-content-center mt-4 mb-5"},[_c('div',{staticClass:"col-md-10 col-xl-8"},[_c('div',{staticClass:"text-center"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }